<template>
    <ClientOnly>
        <template #default>
            <div class="bg-center bg-no-repeat bg-gray-900 h-[592px] md:h-[306px] xl:h-[512px] overflow-hidden">
                <div class="container xl:container md:pl-8 grid md:grid-cols-2 h-full items-end md:items-center">
                    <div class="relative w-full max-w-100 h-auto" v-if="isMobile">
                        <NuxtImg
                            class="h-full max-w-none w-full"
                            loading="lazy"
                            height="200"
                            width="300"
                            fit="cover"
                            :src="properLandingBackground"
                            alt="proper landing"
                        />
                    </div>
                    <div class="z-10 col-span-full md:col-span-1 mb-12 md:mb-0 max-w-[300px] md:max-w-full mx-auto">
                        <div class="md:max-w-[350px] xl:max-w-[511px]">
                            <h2
                                class="xl:text-display-lg text-title-md font-bold text-gray-100 tracking-tighter mb-4 xl:mb-6 text-center md:text-start"
                            >
                                {{ $t("pages_pricing_landing_title-A/B-test") }}
                            </h2>
                            <p
                                class="xl:text-title-sm text-body-md text-gray-200 leading-2 xl:leading-8 mb-4 xl:mb-6 text-center md:text-start"
                            >
                                {{ $t("pages_pricing_landing_subtitle-A/B-test") }}
                            </p>
                        </div>
                        <div
                            class="flex flex-col md:flex-row items-center space-y-3 xl:max-w-[285px] md:space-y-0 md:space-x-3"
                        >
                            <AppButton
                                :id="signupButtonId"
                                class="whitespace-nowrap"
                                @click="openGlobalDialog"
                                block
                                size="md"
                            >
                                {{ $t("pages_pricing_landing_signup-A/B-test") }}
                            </AppButton>
                            <NuxtLink class="w-full whitespace-nowrap" to="/pricing">
                                <AppButton :id="pricingButtonId" block color="white" size="md" variant="outlined">
                                    {{ $t("pages_pricing_landing_seePricing") }}
                                </AppButton>
                            </NuxtLink>
                        </div>
                    </div>
                    <div class="relative w-auto h-full" v-if="isDesktopOrTablet">
                        <NuxtImg
                            class="w-auto h-full max-w-none"
                            loading="lazy"
                            height="400"
                            width="600"
                            fit="cover"
                            :src="properLandingBackground"
                            alt="proper landing"

                        />
                    </div>
                </div>
            </div>
        </template>
        <template #fallback>
            <AppSkeleton type="square" custom-size="w-full h-[592px] md:h-[306px] xl:h-[512px]"> </AppSkeleton>
        </template>
    </ClientOnly>
</template>
<script setup lang="ts">
import { useAuthStore } from "~/features/authentication/store";

const { activeComponent, showAuthModal } = storeToRefs(useAuthStore());

const openGlobalDialog = () => {
    activeComponent.value = "signup";
    showAuthModal.value = true;
};

const { isDesktop, isTablet, isDesktopOrTablet, isMobile } = useDevice();
const properLandingBackground = computed(() => {
    return isDesktop
        ? "/images/pricing/pricing-banner-test.png"
        : isTablet
        ? "/images/pricing/pricing-banner-tablet-test.png"
        : "/images/pricing/pricing-banner-mobile-test.png";
});

const pagePath = computed(() => {
    return useRoute().path === "/" ? "homepage" : useRoute().path.split("/")[1];
});

const signupButtonId = computed(() => {
    return `${pagePath.value}-freeinputs-signup`;
});
const pricingButtonId = computed(() => {
    return `${pagePath.value}-freeinputs-seepricing`;
});
</script>
